import { useSyncExternalStore } from 'react';

export type Summary = { totalFeeUsd: number; totalSwaps: number };

const store = new Map<string, Summary | undefined>();
const listeners = new Set<() => void>();

function subscribe(cb: () => void) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}
function emit() {
  listeners.forEach(l => l());
}

export function setSummary(resource: string, value?: Summary) {
  store.set(resource, value);
  emit();
}

export function getSummary(resource: string) {
  return store.get(resource);
}

export function useSummary(resource: string): Summary | undefined {
  return useSyncExternalStore(
    subscribe,
    () => store.get(resource),
    () => store.get(resource)
  );
}
